import { connect } from "react-redux";
import SiteInspection from "./siteInspection";
import { bindActionCreators } from "redux";
import {
  getSiteInspect,
  getLocationApprovalPending,
  getPocBySiteId,
  postSendReportMail,
  getCheckLocation,
  updateSiteConsumesByOps
} from "services/redux/installation/siteInspection/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";
import {getSiteData, calculateDistance, getDistanceData} from "../../../services/redux/DistanceCalculator/action";
import {
  postReportDetails,
  generateReport,
  previewHandoverValetContract,
} from "services/redux/installation/materialRequisition/action";

import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
  siteData: state.siteInspectionReducer.siteData,
  locationApproval: state.siteInspectionReducer.locationApproval,
  pocListBySiteId: state.siteInspectionReducer.pocListBySiteId,
  locationCheck : state.siteInspectionReducer.locationCheck,
  userProfile : state.loginReducer.userProfile,
  engDistanceData: state.leadDataReducer.engDistanceData,
  siteDetails: state.leadDataReducer.siteData,
  distanceDetails: state.leadDataReducer.distanceDetails,
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteInspect,
      documentUploadUrl,
      postReportDetails,
      generateReport,
      previewHandoverValetContract,
      getLocationApprovalPending,
      getPocBySiteId,
      postSendReportMail,
      getCheckLocation,
      calculateDistance,
      getSiteData,
      getDistanceData,
      documentUploadUrlPublic,
      updateSiteConsumesByOps
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteInspection);
